import { useRef } from "react";

import styles from "./TableSearch.module.css";

const TableSearch = ({ value, onChange, placeholder = "Buscar..." }) => {
  const inputRef = useRef(null);

  const handleClear = () => {
    onChange("");
    inputRef.current?.focus();
  };

  return (
    <div className={styles.search} role="search">
      <i className={`${styles.icon} fas fa-search`} aria-hidden="true" />
      <input
        ref={inputRef}
        type="search"
        className={styles.input}
        value={value}
        placeholder={placeholder}
        aria-label={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
      {value ? (
        <button
          type="button"
          className={styles.clear}
          aria-label="Limpar busca"
          onClick={handleClear}
        >
          <i className="fas fa-times" aria-hidden="true" />
        </button>
      ) : null}
    </div>
  );
};

export default TableSearch;
